import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { MatDrawer } from '@angular/material/sidenav';
import { AbstractService } from './core/abstract.service';
import { Subject } from 'rxjs';
import { AuthService } from './core/auth.service';
import { DemographicsService } from './demographics/demographics.service';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { SharedModulesModule } from './shared/shared-modules.module';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    RouterLink,
    RouterLinkActive,
    RouterOutlet,
    SharedModulesModule,
  ],
  providers: [
    BreakpointObserver,
  ],
})

export class AppComponent extends AbstractService implements OnInit, OnDestroy {
  @ViewChild('drawer') public drawer: MatDrawer;

  profile = {} as any;
  location;
  mobileMode;

  private readonly _destroying$ = new Subject<void>();

  constructor(
    public router: Router,
    private _authService: AuthService,
    private demoservice: DemographicsService,
    private breakpointObserver: BreakpointObserver
  ) {
    super();
    this.breakpointObserver.observe([
      '(max-width: 959px)',
    ]).subscribe((result: BreakpointState) => {
      if (result.matches) {
        this.mobileMode = true;
      } else {
        this.mobileMode = false;
      }
    });
  }

  ngOnInit(): void {
    this._authService.login();
  }

  logout(popup?: boolean) {
    this._authService.logout(popup);
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  drawerToggle(): void {
    this.drawer.toggle();
  }

  drawerClose(): void {
    if (!this.mobileMode) {
      this.drawer.close();
    }
  }
}
